'use client'

import { useState } from 'react'

export function useGalleryViewer() {
  const [activeIndex, setActiveIndex] = useState<number | null>(null)

  return {
    activeIndex,
    openAt: (index: number) => setActiveIndex(index),
    close: () => setActiveIndex(null),
  }
}
